import React from "react";
import { isValid as isDateTimeValid } from "date-fns";
import {
  checkPlanAlreadyInitialized,
  checkPlanAlreadyInitializedRange,
} from "../utils";
import CustomDateRangeComponent from "./CustomDateRangeComponent";
import DateTimeEditorComponent from "./DateTimeEditorComponent";

export function withSelectedDateHoc(Component) {
  return class SelectedDateRender extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        planDate: this.props.planDate,
        dateRange: [
          {
            startDate: this.props.startDate ?? new Date(),
            endDate: this.props.planDate ?? new Date(),
            key: "selection",
          },
        ],
      };
    }

    getSelectedDate = () => {
      return this.props.showDateRange
        ? this.state.dateRange
        : this.state.planDate;
    };

    onDateChanged = (value) => {
      if (!value) {
        this.setState({
          planDate: value,
        });
        return;
      }
      if (value && isDateTimeValid(value)) {
        this.setState({
          planDate: value,
        });
      }
    };

    onDateRangeChange = (ranges) => {
      const { selection } = ranges;
      this.setState({
        dateRange: [selection],
      });
    };

    getPlanDateChangedParams = () => {
      const { planDate, dateRange } = this.state;
      return this.props.showDateRange
        ? [dateRange[0].endDate, dateRange[0]?.startDate]
        : [planDate];
    };

    render() {
      const selectedDate = this.getSelectedDate();
      return (
        <Component
          {...this.props}
          selectedDate={selectedDate}
          getDateComponent={({ terminalDate, holidays, initializedDates }) =>
            this.props.showDateRange ? (
              <CustomDateRangeComponent
                openCalendar={this.state.openCalendar}
                dateRange={selectedDate}
                terminalDate={terminalDate}
                holidays={holidays}
                initializedDates={initializedDates}
                onDateRangeChange={this.onDateRangeChange}
              />
            ) : (
              <DateTimeEditorComponent
                planDate={selectedDate}
                terminalDate={terminalDate}
                holidays={holidays}
                initializedDates={initializedDates}
                onDateChanged={this.onDateChanged}
              />
            )
          }
          checkPlanAlreadyInitialized={
            this.props.showDateRange
              ? checkPlanAlreadyInitializedRange
              : checkPlanAlreadyInitialized
          }
          getPlanDateChangedParams={this.getPlanDateChangedParams}
        />
      );
    }
  };
}
